import { useEffect, useState } from 'react';
import Calendar, { CalendarEvent } from '../../components/calendar/Calendar';
import { DUMMY_EVENTS } from '../../dummy_data/Dummy_Calendar';

const TradingCalendarPage = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  useEffect(() => {
    setEvents(DUMMY_EVENTS);
  }, []);

  return (
    <div>
      <Calendar events={events} />
    </div>
  );
};

export default TradingCalendarPage;
